import { render, staticRenderFns } from "./tipologieProdotti.vue?vue&type=template&id=49bfef5f&"
import script from "./tipologieProdotti.vue.ts?vue&type=script&lang=ts&"
export * from "./tipologieProdotti.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports